import React from "react";
import { EditorBlock } from "draft-js";

import Placeholder from "editor/components/Placeholder";

import { QUOTE_PLACEHOLDER } from "config/constants/editor";

import styles from "./PlainQuote.css";

export default class PlainQuote extends React.Component {
  constructor() {
    super();
    this.state = { quoteElement: null };
  }

  isPlaceholderVisible() {
    return this.props.block.getText().length === 0;
  }

  render() {
    return (
      <div
        className={styles.root}
        ref={element => {
          if (!this.state.quoteElement)
            this.setState({ quoteElement: element });
        }}
      >
        <Placeholder isVisible={this.isPlaceholderVisible()}>
          {QUOTE_PLACEHOLDER}
        </Placeholder>
        <EditorBlock {...this.props} />
      </div>
    );
  }
}
